import React from 'react';

import Input from './Input';


const rule1 = [

        {
            pattern: new RegExp(/^[0-9]+(.[0-9]+)?$/),
            message: '请输入一个浮点数',
        },
];

const rule2 = [

  {
    pattern: new RegExp(/^[0-9]+(.[0-9]+)?$/),
    message: '请输入一个浮点数',
  },
  {
    required: true,
    message: '此项不能为空',
  }
];

const InputDouble = (props) => (
    <Input {...props} rules={props.noNull ? rule2 : rule1}></Input>
);

export default InputDouble;